import * as React from "react";
const HealthIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 56 56",
  "aria-hidden": "true",
  fill: "currentColor",
  width: "1em",
  height: "1em",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#health_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32 7a3 3 0 0 0-6 0v3h6V7Zm-6 23h6v-2h5a8 8 0 0 0 0-16H22.64A4 4 0 0 0 20 11h-5a4 4 0 1 0 0 8h5a4 4 0 0 0 2.64-1H37a2 2 0 0 1 0 4h-5v-2h-6v2h-3a8 8 0 0 0 0 16h10a2 2 0 0 1 0 4h-1v-2h-6v2h-2a3 3 0 0 0 0 6h2v1c-.002.342.059.68.18 1 .048.145.108.285.18.42.03.072.07.14.12.2a2.9 2.9 0 0 0 1.46 1.18c.053.03.11.05.17.06.067.03.138.05.21.06a.86.86 0 0 0 .17.03c.337.067.683.067 1.02 0a.86.86 0 0 0 .17-.03 2.952 2.952 0 0 0 1.84-1.3c.05-.06.09-.128.12-.2.072-.135.132-.275.18-.42.121-.32.182-.658.18-1v-1h1a8 8 0 0 0 0-16H23a2 2 0 0 1 0-4h3v2ZM15 15a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "health_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h56v56H0z"
}))));
export default HealthIcon;